import { Component, inject, OnInit, signal } from '@angular/core';
import { AuthPageLayoutComponent } from '../../../shared/layout/auth-page-layout/auth-page-layout.component';
import { SigninFormComponent } from '../../../shared/components/auth/signin-form/signin-form.component';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';
import { CommonService } from '../../../services/common/common.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  standalone: true,
  selector: 'app-sign-in',
  imports: [
    AuthPageLayoutComponent,
    SigninFormComponent,
    ToastModule
  ],
  templateUrl: './sign-in.component.html',
  styles: ``
})
export class SignInComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router)
  private commonService = inject(CommonService)
  private messageService = inject(MessageService)
  private route = inject(Router)
  checking = signal(true);

  ngOnInit() {
    this.checkLogin();
  }

  async checkLogin() {
    this.checking.set(true);
    if (await this.authService.isLoggedIn()) {
      this.commonService.getProfileDetails().subscribe({
        next: (res: any) => {
          this.checking.set(false)
          localStorage.setItem("userDetails", JSON.stringify(res))
          this.router.navigate(['/']);
        },
        error: (err: any) => {
          this.checking.set(false);
          const errorDetail = err?.error?.detail || '';
          if (errorDetail.toLowerCase().includes('pending')) {
            this.route.navigate(['/pending-user']);
          }
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: errorDetail || 'Login failed!'
          });
        }
      })
    } else {
      this.checking.set(false);
    }
  }
}
